module.exports = __webpack_public_path__ + "img/i_phonefee_op_phone.96c6c402.svg";